import type { ReactNode } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { resolveRegistrationLegalReturnTo } from "../../lib/legalConsent";
import { resolvePublicLpReturnTo } from "../../lib/publicLpReturn";

type LegalPageShellProps = {
  children: ReactNode;
};

const backLinkClassName = "text-sm font-bold text-[#A67C52] hover:text-[#7C5A4E]";

export default function LegalPageShell({ children }: LegalPageShellProps) {
  const [searchParams] = useSearchParams();
  const requestedReturnTo = searchParams.get("returnTo");
  const backDestination = resolvePublicLpReturnTo(requestedReturnTo)
    ?? resolveRegistrationLegalReturnTo(requestedReturnTo);

  return (
    <main className="min-h-screen bg-[#FDF8F5] px-6 py-10 text-[#4A3E39] antialiased">
      <article className="mx-auto max-w-3xl rounded-[2rem] border border-[#EADBC8] bg-white px-6 py-8 shadow-[0_14px_28px_rgba(166,124,82,0.10)] md:px-10">
        <header className="mb-8 flex items-center justify-between gap-4">
          <Link to={backDestination} className={backLinkClassName}>
            ←戻る
          </Link>
          <Link to="/home" className="text-xs font-bold text-[#9C867D] hover:text-[#7C5A4E]">
            WizMate
          </Link>
        </header>
        <div className="space-y-6 text-sm leading-7 text-[#5D4D46]">
          {children}
          <footer className="border-t border-[#EADBC8] pt-6">
            <Link to={backDestination} className={backLinkClassName}>
              ←戻る
            </Link>
          </footer>
        </div>
      </article>
    </main>
  );
}
